module.exports = __webpack_public_path__ + "static/media/background.05df34a4.png";